import * as yup from 'yup';

export interface BillType{
    bill_detail_id: number,
    quantity_bill: number,
    quantity_unit: number,
    product_id: number,
    price_bill: number,
    discount: number,
    total: number,
    tax_id: number,
    company_code: string,
    tax_rate: number,
    total_tax_paid: number,
    transaction_date:string,
    product_name: string,
    vendor_description: string,
    tax_name: string,
    unit_convention_id: number,
    unit_convention: string,
    unit_measure_id: number,
    unit_measure: string,
    total_qty_reject: number,
    total_nilai_reject: number,
    total_tax_reject: number,
    project_id: number,
    vendor_id: number,
    vendor_name: string,
    trx_code: string,
    project_boq_id: number,
    boq_name: string
    project_transaction_id: number | null,
}

export interface FormBillType {
    bills: BillType[];
}

export const billTransactionSchema = yup.object().shape({
    project_id: yup.number().required(),
    trx_source: yup.number().required(),
    trx_source_id: yup.number().required(),
    trx_date: yup.string().required(),
    trx_amount: yup.number().required(),
    project_boq_id:yup.number().required(),
});

export type FormBillBoqType = yup.InferType<typeof billTransactionSchema>;